import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'

import { OperatorDataState } from '@states/operator-data'

const NOT_ALLOWED_PATH_LIST = [`/security/oauth/token`, `/notifications/chat`]

const bodyParser = (body: unknown): Record<string, unknown> => {
	if (typeof body === 'string') return JSON.parse(body)

	return body as Record<string, unknown>
}

export const operatorBodyInterceptor: HttpInterceptorFn = (req, next) => {
	const operatorDataState = inject(OperatorDataState)
	const metadata = operatorDataState.metadata()

	if (!metadata || NOT_ALLOWED_PATH_LIST.some(url => req.url.includes(url)) || !req.body) {
		return next(req)
	}

	const parsedBody = bodyParser(req.body)
	const { operatorCompanyId, parkingLocationId } = metadata
	const body = JSON.stringify({ operatorCompanyId, parkingLocationId, ...parsedBody })

	return next(req.clone({ body }))
}
